export default "__VITE_ASSET__BLNM16ma__"